module.exports = __webpack_public_path__ + "static/media/searchIcon.0c75954e.svg";